module.exports = __webpack_public_path__ + "media/images/icons/credit_card/diners-aff7c7b11c7af7200940f1164b1e84dd.png";